'use strict';

const { pubdb } = Function('return this')();
const {
    $, window, mustache, DISPLAY_MARKUPS, echo, encodeBooleanSearch, ajax_get, next_tick, kb_ev_up_down_enter,
    encode_uri_component,
} = pubdb;
const { alert, setTimeout } = window;


let form, q, pubdb_data;

let journals;
let old_text;
let timeout = false;
let cache = Object.create(null);


function submit () {
    var elem = $('input[name=journal]:checked', form);
    if (!elem.length) {
        alert('Sie haben keine Fachzeitschrift ausgewählt.');
        return;
    }

    var id = +elem.attr('value');
    for (var i = 0, len = journals.length; i < len; ++i) {
        if (journals[i].id === id) {
            window[pubdb.callback](journals[i]);
            return ;
        }
    }
}


function success (data) {
    if (!data) {
        return;
    } else if (!data.length) {
        pubdb_data.html(mustache(DISPLAY_MARKUPS.NO_RESULTS_YET, {}));
        return;
    }
    journals = data;
    journals.sort(function (a, b) {
        a = a.title;
        b = b.title;
        return a < b ? -1 : a > b ? +1 : 0;
    });

    pubdb_data.html(mustache(
        '<ul class="no-image-list">' +
            '{{#journals}}' +
                '<li>' +
                    '<label style="font-weight:normal">' +
                        '<input type="radio" name="journal" value="{{id}}" style="display:inline" />' +
                        '{{title}}{{#issn}} – {{issn}}{{/}}' +
                    '</label>' +
                '</li>' +
            '{{/}}' +
        '</ul>',
        {journals:journals, single_object:data.length}
    ));
    $(':radio:first', pubdb_data).prop('checked', true);
}


function req_error (data, err, xhr) {
    echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
}


function search () {
    timeout = false;

    var new_text = encodeBooleanSearch(q.val());
    if (!new_text || old_text === new_text) {
        return;
    }
    old_text = new_text;

    new_text = encode_uri_component(new_text + '*');
    if (new_text in cache) {
        success(cache[new_text]);
    } else {
        ajax_get(form.attr('action') + '?q=' + new_text, (function (text) {
            return function (data) {
                cache[text] = data;
                success(data);
            };
        })(new_text), req_error);
    }
}


$(function () {
    form = $('#main_form');
    q = $('input[name=q]', form);
    pubdb_data = $('#pubdb_data');

    form.on('submit', function (ev) {
        ev.preventDefault();
        next_tick(submit);
    });

    q.on('change keydown keyup blur', function () {
        if (timeout) {
            return;
        }

        timeout = true;
        setTimeout(search, 200);
    }).on('keydown', function (ev) {
        const up_down_enter = kb_ev_up_down_enter(ev);
        if (!up_down_enter) {
            return;
        }

        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();

        if (up_down_enter === 'Enter') {
            submit();
            return;
        }

        const radios = $(':radio', pubdb_data);
        const { length } = radios;
        if (!radios.length) {
            return;
        }

        let index;
        for (index = 0; index < length; ++index) {
            if (radios.eq(index).is(':checked')) {
                break;
            }
        }
        if (up_down_enter === 'ArrowUp') {
            if (--index < 0) {
                index = length - 1;
            }
        } else {
            if (++index >= length) {
                index = 0;
            }
        }

        radios.eq(index).prop('checked', true);
    });

    q.focus();
});
